import type { TranscriptionIssuePayload } from '@Application/WorkflowRuns/WorkflowRun/Actions/workflowRunFetched';
import LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * The failing or blocked step of an interview's latest transcription run. `message`,
 * `isConfigurationFailure`, `isStalled` and `canRetry` are server decisions, never recomputed here;
 * retrying targets `runId` and `stepRunId`.
 */
class TranscriptionIssueView {
	readonly runId: number;
	readonly stepRunId: number;
	readonly step: LabeledValueView;
	readonly isStalled: boolean;
	readonly message: string;
	readonly isConfigurationFailure: boolean;
	readonly canRetry: boolean;

	constructor(payload: TranscriptionIssuePayload) {
		this.runId = payload.run.id;
		this.stepRunId = payload.stepRun.id;
		this.step = new LabeledValueView(payload.step);
		this.isStalled = payload.isStalled;
		this.message = payload.message;
		this.isConfigurationFailure = payload.isConfigurationFailure;
		this.canRetry = payload.canRetry;

		Object.freeze(this);
	}
}

export default TranscriptionIssueView;
